import React, {Fragment, Suspense} from 'react';
import './assets/legacy.css';
import LegacyFrame from "./LegacyFrame";
import {getSessionValue} from "../../Common/Appcommon";

class Leads extends React.Component {

    render() {
        let leadFormname = getSessionValue('leadformname');
        return (
            <LegacyFrame withHeader={true} pageTitle={"Leads"} formname={leadFormname} customFrameClass={"leads-container"} customClass={"field-customization-container"} />
        );
    }
}

export default Leads;
